//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import AssistantIcon from '@mui/icons-material/Assistant';
import { type SvgIconProps } from '@mui/material/SvgIcon';

// The chat panel's registry id, in a leaf module so the panel's body, its
// registrar and its launcher can all name the same panel without importing
// one another: the registrar already imports the body.
export const CHAT_PANEL_ID = 'chat';

// The data-joyride-id values the chat content marks its parts with, for a
// tour that must point at them.
export const CHAT_TOUR_ANCHORS = {
  message: 'chat-message',
  toolbar: 'chat-toolbar'
} as const;

// Why chat's launcher refuses when it does. Chat has two launchers -- the
// taskbar pill and the mobile header's own -- and the reason must read the
// same from both.
export const CHAT_DISABLED_REASON = 'no model configured';

// The one name for chat, spoken by its panel spec, the header's Tools row and
// the taskbar pill alike.
export const CHAT_PANEL_TITLE = 'Ask AI';

// A factory rather than a frozen element: the taskbar draws this icon inline
// (`fontSize="inherit"`) while the panel spec wants the icon's own default
// size, and one element cannot carry two different prop sets.
export const chatPanelIcon = (props?: SvgIconProps) => (
  <AssistantIcon {...props} />
);
